module.exports = __webpack_public_path__ + "img/20_1.63078572.png";